import { createFileRoute } from '@tanstack/react-router';
import { DadosDaAcademia } from '@/features/empresa/componentes/DadosDaAcademia';
import { rotaDeTela } from '@/features/permissoes/guardas';

/** Dados da academia (spec 012, CA-01 a CA-03). */
export const Route = createFileRoute('/_autenticado/configuracoes/empresa')({
  ...rotaDeTela('empresa.dados'),
  component: DadosDaAcademia,
});
